module.exports = __webpack_public_path__ + "static/media/Bridgets.22063b10.ico";